import { OpenLab } from "./OpenLab.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  OpenLab
};
//# sourceMappingURL=index.js.map
